import { render, staticRenderFns } from "./StageRegister.vue?vue&type=template&id=6d6ac98a&scoped=true&"
import script from "./StageRegister.vue?vue&type=script&lang=js&"
export * from "./StageRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ac98a",
  null
  
)

export default component.exports